<template>
	<div class="forms">
		<v-layout row wrap class="div-layout-container-page" v-if="typeRegistration === 'affiliate'">
			<v-flex x12 sm9 md6 class="div-container-create-account">
				<div class="div-routes">
					<button
						:class="`div-routes-${typeRegistration === 'affiliate'}`"
						v-on:click="handleSubmitTypeRegistration('affiliate')"
					>
						Afiliado
					</button>
					<button
						:class="`div-routes-${typeRegistration === 'advertiser'}`"
						v-on:click="handleSubmitTypeRegistration('advertiser')"
					>
						Anunciante
					</button>
				</div>
				<div class="div-layout-affiliate-forms">
					<div class="div-container-box-create-affiliate" v-if="stepForm === 1">
						<v-form
							ref="form"
							v-model="valid1"
							@submit.prevent="buttonContinueAffiliate"
							lazy-validation
						>
								<p class="div-forms-affiliate-title">Crie sua conta</p>
								<p class="div-forms-affiliate-description">Fácil e rápido!</p>
								<div class="div-forms-create-affiliate">
									<v-text-field
										label="Email"
										:rules="rules.email"
										v-model="aff.email"
										outline
									/>
									<v-text-field
										label="Telefone"
										:rules="requiredRule"
										v-model="aff.address.phone"
										mask="(##) #########"
										return-masked-value
										outline
									></v-text-field>
									<v-text-field
										v-model="aff.password"
										label="Senha"
										:rules="passwdRules"
										required
										type="password"
										outline
									></v-text-field>
									<v-text-field
										v-model="confirmPassword"
										label="Confirme a Senha"
										:rules="ConfirmPasswdRules"
										required
										type="password"
										outline
									></v-text-field>
								</div>
								<div class="container-vue-recaptcha">
									<vue-recaptcha
										ref="recaptcha"
										sitekey="6LekgKUdAAAAADLGSwNgvvrvXoeOnhYqxaw38olj"
										@verify="verifyMethod"
										@expired="expiredMethod"
										@error="errorMethod"
									/>
								</div>
								<div class="div-forms-create-affiliate-button">
									<button
										class="button-continue"
										type="submit"
										:disabled="
										(aff.email.length == 0 ||
										aff.address.phone.length == 0 ||
										aff.password.length == 0 ||
										confirmPassword.length == 0 ||
										(aff.password.length !== confirmPassword.length) ||
										(aff.password !== confirmPassword)) && !valid1 || !statusButton
									"
									>
										Continuar
									</button>
								</div>
						</v-form>
					</div>
					<div class="div-container-box-create-affiliate" v-if="stepForm === 2">
						<v-form
							ref="form"
							v-model="valid"
							@submit.prevent="handleSubmitAffiliateCompletedRegistration"
							lazy-validation
						>
							<div class="div-buttons-type-person">
								<div class="div-align-button">
									<button
										:class="`${aff.register.reg_type === 'fisica'}`"
										v-on:click="handleSubmitTypePerson('fisica')"
									>
										Pessoa Física
									</button>
									<button
										:class="`${aff.register.reg_type === 'juridica'}`"
										v-on:click="handleSubmitTypePerson('juridica')"
									>
										Pessoa Jurídica
									</button>
								</div>
							</div>
							<div class="div-forms-create-affiliate">
								<v-text-field
									:label="aff.register.reg_type == 'fisica' ? 'CPF ' : 'CNPJ'"
									:rules="aff.register.reg_type == 'fisica' ? rules.cpf : rules.cnpj"
									:mask="
										aff.register.reg_type == 'fisica'
											? '###.###.###-##'
											: '##.###.###/####-##'
									"
									v-model="aff.register.reg_code"
									return-masked-value
									outline
								></v-text-field>
								<v-text-field
									:label="
										aff.register.reg_type == 'fisica' ? 'Nome Completo' : 'Razão Social'
									"
									:rules="requiredRule"
									v-model="aff.register.reg_name"
									outline
								></v-text-field>
								<div class="div-forms-page-groups">
									<p class="title-groups">Grupos</p>
									<p class="description-groups">
										Os campos abaixo são ralacionados às redes onde você fará suas divulgações.
										Basta inserir o grupo em que você melhor se encaixa!
									</p>
								</div>
								<v-select
									:items="dados"
									:rules="requiredSelectRule"
									v-model="aff.group"
									attach
									chips
									label="Grupos de Divulgação (Ex: Whatsapp, Instagram)"
									multiple
								></v-select>
								<v-text-field
									label="Site de Divulgação (Ex: Link do seu instagram, Facebook)"
									:rules="requiredRule"
									v-model="aff.site"
									outline
								></v-text-field>
								<div class="div-politicy-platform">
									<p class="paragrafo-politicy-platform">
										Ao cadastrar-se, você declara
										aceitar nossos <a href="https://magafilio-public.s3-sa-east-1.amazonaws.com/termos-de-uso.pdf" target="_blank">Termos de Uso</a> e
										nossa <a href="https://magafilio-public.s3-sa-east-1.amazonaws.com/termos-de-uso.pdf" target="_blank">Política de Privacidade</a>.
									</p>
								</div>
								<div class="div-completed-registration">
									<button
										v-if="!loadingAffiliate"
										v-on:click="handleBackRegistrationStepOne"
										class="button-back-registration"
									>
										Voltar
									</button>
									<button
										v-if="!loadingAffiliate"
										class="button-completed-registration"
										type="submit"
										:disabled="
											(aff.register.reg_type.length == 0 ||
											aff.register.reg_name.length == 0 ||
											aff.register.reg_code.length == 0 ||
											aff.group.length == 0 ||
											aff.site.length == 0) && !valid
										"
									>
										Concluir Cadastro
									</button>
									<v-progress-circular
										v-else
										indeterminate
										color="primary"
									></v-progress-circular>
								</div>
							</div>
						</v-form>
					</div>
				</div>
				<div class="div-container-button-back-to-login hidden-md-and-up">
					<router-link class="button-back-login-affiliate-forms" to="/login">
						<v-icon class="icon-affiliate-forms">keyboard_backspace</v-icon>
						Voltar para o acesso
					</router-link>
				</div>
			</v-flex>
			<v-flex xs12 sm12 md5 class="div-container-create-account-description hidden-sm-and-down">
				<div class="div-container-affiliate-forms"  v-if="stepForm === 1">
					<img
						src="../assets/logo_magafilio_branco.svg"
						alt="Logo Magafilio"
						class="logo-magafilio-img"
					/>
					<div class="div-container-description-forms">
						<p class="title-affiliate-forms">
							<span>+</span>4500 afiliados já
							fazem parte desta
							comunidade!
						</p>
						<p class="description-affiliate-forms">
							Cadastre-se e alcance sua verdadeira independência.
						</p>
					</div>
					<router-link class="button-back-login-affiliate-forms" to="/login">
						<v-icon class="icon-affiliate-forms">keyboard_backspace</v-icon>
						Voltar para o acesso
					</router-link>
				</div>
				<div class="div-container-affiliate-forms"  v-if="stepForm === 2">
					<img
						src="../assets/logo_magafilio_branco.svg"
						alt="Logo Magafilio"
						class="logo-magafilio-img"
					/>
					<div class="div-container-description-forms">
						<p class="title-affiliate-forms">
							Conclua seu cadastro e assuma o controle
						</p>
						<p class="description-affiliate-forms">
							Cadastre-se e alcance sua verdadeira independência.
						</p>
					</div>
					<router-link class="button-back-login-affiliate-forms" to="/login">
						<v-icon class="icon-affiliate-forms">keyboard_backspace</v-icon>
						Voltar para o acesso
					</router-link>
				</div>
			</v-flex>
		</v-layout>
		<v-layout row wrap v-else-if="typeRegistration === 'advertiser'" class="div-layout-container-page">
			<v-flex x12 sm9 md6 class="div-container-create-account">
				<div class="div-routes">
					<button
						:class="`div-routes-${typeRegistration === 'affiliate'}`"
						v-on:click="handleSubmitTypeRegistration('affiliate')"
					>
						Afiliado
					</button>
					<button
						:class="`div-routes-${typeRegistration === 'advertiser'}`"
						v-on:click="handleSubmitTypeRegistration('advertiser')"
					>
						Anunciante
					</button>
				</div>
				<div class="div-layout-affiliate-forms">
				<v-form
					ref="form"
					v-model="valid2"
					@submit.prevent="handlebuttonRegistrationAdvertiser"
					lazy-validation
				>
						<div class="div-container-box-create-advertiser">
							<p class="paragrafo-title-advertiser hidden-sm-and-down">
								Quero ter sucesso no meu ecommerce
							</p>
							<p class="paragrafo-title-advertiser-cellphone hidden-md-and-up">
								O sucesso do seu ecommerce está a alguns passos
							</p>
							<p class="paragrafo-description-advertiser-cellphone hidden-md-and-up">
								Tenha acesso a nossa rede de afiliados dedicados
								e turbine os resultados do seu ecommerce!
							</p>
							<div class="div-forms-create-advertiser">
								<v-text-field
									label="Razão Social"
									:rules="requiredRule"
									v-model="adv.register.reg_name"
									outline
								/>
								<v-text-field
									label="CNPJ"
									:rules="rules.cnpj"
									mask="##.###.###/####-##"
									v-model="adv.register.reg_code"
									outline
								/>
								<v-text-field
									label="Email para contato"
									:rules="rules.email"
									v-model="adv.email"
									outline
								/>
								<v-text-field
									label="Link do site"
									:rules="requiredRule"
									v-model="adv.url_site"
									outline
								/>
								<v-text-field
									label="Plataforma de ecommerce que utiliza"
									:rules="requiredRule"
									v-model="adv.platform"
									outline
								/>
								<v-text-field
									label="Média de acessos mensais"
									:rules="requiredRule"
									v-model="adv.qtdAccessForMonth"
									outline
								/>
								<v-text-field
									label="Como chegou até a Magafilio?"
									:rules="requiredRule"
									v-model="adv.howKnowMagafilio"
									outline
								/>
							</div>
							<div class="container-vue-recaptcha">
								<vue-recaptcha
									ref="recaptcha"
									sitekey="6LekgKUdAAAAADLGSwNgvvrvXoeOnhYqxaw38olj"
									@verify="verifyMethod"
									@expired="expiredMethod"
									@error="errorMethod"
								/>
							</div>
							<div class="div-forms-create-advertiser-button">
								<button
									v-if="!loadingAdvertiser"
									class="button-registration-advertiser"
									type="submit"
									:disabled="
									(adv.register.reg_name.length == 0 ||
									adv.register.reg_code.length == 0 ||
									adv.url_site.length == 0 ||
									adv.platform.length == 0 ||
									adv.email == 0 ||
									adv.qtdAccessForMonth.length == 0 ||
									adv.howKnowMagafilio.length == 0) && !valid2 || !statusButton
								"
								>
									Solicitar
								</button>
								<v-progress-circular
									v-else
									indeterminate
									color="primary"
								></v-progress-circular>
							</div>
						</div>
					</v-form>
				</div>
			</v-flex>
			<v-flex xs12 sm12 md5 class="div-container-create-account-description hidden-sm-and-down">
				<div class="div-container-affiliate-forms">
					<img
						src="../assets/logo_magafilio_branco.svg"
						alt="Logo Magafilio"
						class="logo-magafilio-img"
					/>
					<div class="div-container-description-forms">
						<p class="title-affiliate-forms">
							O sucesso do seu ecommerce está a alguns passos
						</p>
						<p class="description-affiliate-forms">
							Tenha acesso a nossa rede de afiliados
							dedicados e turbine os resultados do seu ecommerce!
						</p>
					</div>
					<router-link class="button-back-login-affiliate-forms" to="/login">
						<v-icon class="icon-affiliate-forms">keyboard_backspace</v-icon>
						Voltar para o acesso
					</router-link>
				</div>
			</v-flex>
		</v-layout>
		<v-dialog v-model="showDialogStatusSuccess" max-width="400" persistent scrollable>
			<div class="dialog-success-formulario">
					<p class="welcome">Bem-vindo(a)!</p>
					<p>Seu cadastro está em <strong>análise</strong>.</p>
					<p>Assim que liberado, você receberá a confirmação por <strong>e-mail</strong></p>
					<p>Até lá, acompanhe a Magafilio nas redes:</p>
					<div class="div-buttons-social-network">
						<div class="insta">
							<a href="https://www.instagram.com/magafilio/" target="_blank">
								<img src="../assets/insta.svg" alt="Logo insta">
								Instagram
							</a>
						</div>
						<div class="face">
							<a href="https://www.facebook.com/Magafilio-101391891410128" target="_blank">
								<img src="../assets/face.svg" alt="Logo insta">
								Facebook
							</a>
						</div>
					</div>
					<button class="button-back-login-affiliate-forms" v-on:click="handlebuttonPressionedInformation">
						<v-icon class="icon-affiliate-forms">keyboard_backspace</v-icon>
						Voltar para o acesso
					</button>
			</div>
		</v-dialog>
		<v-dialog v-model="showDialogStatusSuccessAdvertiser" max-width="400" persistent scrollable>
			<div class="dialog-success-formulario">
					<p class="welcome">Obrigado(a)!</p>
					<p>Suas informações estão em <strong>análise</strong>.</p>
					<p>Ao analisarmos sua loja, entraremos em contato por <strong>e-mail</strong></p>
					<p>Até lá, acompanhe a Magafilio nas redes:</p>
					<div class="div-buttons-social-network">
						<div class="insta">
							<a href="https://www.instagram.com/magafilio/" target="_blank">
								<img src="../assets/insta.svg" alt="Logo insta">
								Instagram
							</a>
						</div>
						<div class="face">
							<a href="https://www.facebook.com/Magafilio-101391891410128" target="_blank">
								<img src="../assets/face.svg" alt="Logo insta">
								Facebook
							</a>
						</div>
					</div>
					<button class="button-back-login-affiliate-forms" v-on:click="handlebuttonPressionedInformationAdvertiser">
						<v-icon class="icon-affiliate-forms">keyboard_backspace</v-icon>
						Voltar para o acesso
					</button>
			</div>
		</v-dialog>
	</div>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha'
import { affiliate_api } from '@/api'
import validators from '@/utils/validators'

const emptyAffiliate = {
	email: '',
	password: '',
	site: '',
	register: {
		reg_type: 'fisica',
		reg_name: '',
		reg_code: '',
	},
	address: {
		street: '',
		street_n: undefined,
		complement: '',
		cep: '',
		city: '',
		state: '',
		phone: '',
	},
	bank_info: {
		reg_type: 'fisica',
		holder_name: '',
		holder_doc: '',
		bank_name: '',
		office: '',
		account: '',
		type: '1',
	},
	nickname: '',
	group: [],
	active: true,
}

const emptyAdvertiser = {
	register: {
		reg_name: '',
		reg_code: ''
	},
	email: '',
	url_site: '',
	platform: '',
	qtdAccessForMonth: '',
	howKnowMagafilio: ''
}

const cpfMask = /[0-9]{3}.[0-9]{3}.[0-9]{3}-[0-9]{2}/
const cnpjMask = /[0-9]{2}.[0-9]{3}.[0-9]{3}\/[0-9]{4}-[0-9]{2}/

export default {
	name: 'Forms',
	mixins: [affiliate_api],
	components: {
		VueRecaptcha
	},
	data() {
		return {
			statusButton: false,
			loadingAdvertiser: false,
			loadingAffiliate: false,
			showDialogStatusSuccess: false,
			showDialogStatusSuccessAdvertiser: false,
			valid: true,
			valid1: true,
			valid2: true,
			stepForm: 1,
			typeRegistration: 'affiliate',
			confirmPassword: '',
			aff: emptyAffiliate,
			adv: emptyAdvertiser,
			dados: [
				{ text: 'Cupom', value: 'coupon' },
				{ text: 'On Page', value: 'onpage' },
				{ text: 'Cashback', value: 'cashback' },
				{ text: 'E-mail Marketing', value: 'emailmkt' },
				{ text: 'On Site', value: 'onsite' },
				{ text: 'Comparador de Preço', value: 'comprice' },
				{ text: 'Grupo/Página Facebook', value: 'groupwhatsapp' },
				{ text: 'WhatsApp/Telegram', value: 'whatstelegram' },
				{ text: 'Página Instagram', value: 'pageinstagram' },
				{ text: 'Blog Especializado', value: 'blog' },
				{ text: 'Site de Promoção', value: 'site' },
				{ text: 'Canal do Youtube', value: 'youtube' },
				{ text: 'Rede de Afiliados', value: 'network' },
				{ text: 'Outros', value: 'other' },
			],
			rules: {
				cpf: validators.cpf,
				cnpj: validators.cnpj,
				domain: validators.domain,
				email: validators.email,
				required: validators.required,
			},
			cpfRules: [(v) => cpfMask.test(v) || 'CPF inválido'],
			cnpjRules: [(v) => cnpjMask.test(v) || 'CNPJ inválido'],
			requiredRule: [(v) => !!v || 'Campo requerido'],
			requiredSelectRule: [(v) => v.length != 0 || 'Campo requerido'],
			passwdRules: [
				(v) => !!v || 'Campo requerido',
				(v) =>
					(v !== undefined && v.length >= 6) ||
				'Senha deve ter no mínimo 6 caracteres',
			],
		}
	},
	computed: {
		ConfirmPasswdRules: function () {
			return [
				(v) => !!v || 'Campo requerido',
				(v) => v === this.aff.password || 'As senhas precisam ser iguais',
			]
		},
	},
	methods: {
		verifyMethod: async function(recaptchaToken) {
			await this.validate_google_recaptcha(recaptchaToken)

			this.statusButton = true
		},
		expiredMethod: function() {
			this.statusButton = false
		},
		errorMethod: function(err) {
			console.log(err)
		},
		buttonContinueAffiliate: function() {
			if (!this.$refs.form.validate()) {

				this.$notify({
					type: 'error',
					title: 'Cadastro com informação inválida, verifique suas informações!',
				})

				return
			}

			this.stepForm = 2

		},
		handleSubmitTypePerson: function(typePerson) {
			this.aff.register.reg_type = typePerson
		},
		handleBackRegistrationStepOne: function() {
			this.stepForm = 1
		},
		handleSubmitTypeRegistration: function(typeRegistration) {
			this.typeRegistration = typeRegistration
		},
		handlebuttonPressionedInformation: function () {
			this.showDialogStatusSuccess = false
			this.aff.email = ''
			this.aff.register.reg_code = ''
			this.aff.register.reg_name = ''
			this.aff.address.phone = ''
			this.aff.group = ''
			this.aff.site = ''
			this.aff.password = ''
			this.confirmPassword = ''
			this.$router.push('/login')
		},
		handlebuttonPressionedInformationAdvertiser: function () {
			this.showDialogStatusSuccessAdvertiser = false
			this.adv.register.reg_code = ''
			this.adv.register.reg_name = ''
			this.adv.email = '',
			this.adv.url_site = ''
			this.adv.platform = ''
			this.adv.qtdAccessForMonth = ''
			this.adv.howKnowMagafilio = ''
			this.$router.push('/login')
		},
		handleSubmitAffiliateCompletedRegistration: async function() {
			try {
				if (!this.$refs.form.validate()) {

					this.$notify({
						type: 'error',
						title: 'Cadastro com informação inválida, verifique suas informações!',
					})

					return
				}

				this.loadingAffiliate = true

				let afiliado = await this.get_create_affiliate(
					this.aff,
					this.$route.fullPath.split('=')[1] // sabemos que o cadastro vem da loja
				)

				this.loadingAffiliate = false

				if (afiliado.data.msg) {

					this.showDialogStatusSuccess = true

				} else {

					this.$notify({
						type: 'error',
						title: `${afiliado.data.mensagem}!`,
					})

				}

			} catch (err) {

				this.$notify({
					type: 'error',
					title: 'Cadastro não concluído, verifique suas informações!',
				})

				this.loadingAffiliate = false

			}
		},
		handlebuttonRegistrationAdvertiser: async function() {
			try {

				if (!this.$refs.form.validate()) {

					this.$notify({
						type: 'error',
						title: 'Cadastro com informação inválida, verifique suas informações!',
					})

					return
				}

				this.loadingAdvertiser = true

				let advertiser = await this.registrationAdvertiser(this.adv)

				this.loadingAdvertiser = false

				if(advertiser.data.msg) {
					this.showDialogStatusSuccessAdvertiser = true
				}

			} catch (err) {

				this.$notify({
					type: 'error',
					title: 'Cadastro não concluído!',
				})

			}
		}
	},
	watch: {
		stepForm: function(value) {
			if (value == 1) {
				this.statusButton = false
			}
		}
	}
}
</script>

<style>

.div-layout-container-page {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.div-container-create-account {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 95vh;
}

.div-container-create-account .div-routes {
	width: 70%;
	display: flex;
	align-items: center;
	justify-content: space-evenly;
	margin-bottom: 30px;
}

.div-container-create-account .div-routes button.div-routes-true {
	background: #40DA99;
	box-shadow: inset 2px 2px 4px rgba(0, 0, 0, 0.25), inset -2px -2px 4px rgba(255, 255, 255, 0.25);
	border-radius: 11px;
	padding: 8px 20px;
	color: #2D2F32 !important;
	font-weight: 500;
	border: 1px solid #FFFFFF;
}

/* .div-container-create-account .div-routes button.div-routes-false:hover {
	border: 1px solid #40DA99;
	box-shadow: inset 2px 2px 4px rgba(0, 0, 0, 0.25), inset -2px -2px 4px rgba(255, 255, 255, 0.25);
	border-radius: 11px;
	padding: 8px 20px;
	font-weight: 500;
} */

.div-container-create-account .div-container-box-create-affiliate p.div-forms-affiliate-title {
	font-size: 28px;
	font-weight: 700;
	margin-bottom: 0px;
	color: #FFFFFF !important;
}

.div-container-create-account .div-container-box-create-affiliate p.div-forms-affiliate-description {
	opacity: 0.7;
	font-size: 12px;
	margin-bottom: 25px;
}

.div-container-create-account .div-layout-affiliate-forms {
	background: #2D2F32;
	box-shadow: 9px 9px 16px rgba(0, 0, 0, 0.25), -9px -9px 16px rgba(74, 74, 74, 0.25);
	border-radius: 23px;
	padding: 20px 40px;
	width: 100%;
}

.div-forms-create-affiliate-button {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 15px;
}

.div-forms-create-affiliate-button button.button-continue {
	background: #40DA99;
	box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.5), -3px -3px 8px rgba(74, 74, 74, 0.5);
	border-radius: 23px;
	padding: 8px 20px;
	color: #2D2F32 !important;
	font-weight: 500;
	transition: background 0.6s;
}

.div-forms-create-affiliate-button button.button-continue:hover {
	background: #FFFFFF;
}

.div-forms-create-affiliate-button button.button-continue:disabled {
	opacity: 0.4;
	background: #40DA99;
	color: #2D2F32 !important;
	cursor: not-allowed;
}


.div-container-create-account-description {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 95vh;
	margin-left: 10px;
}

.div-container-create-account-description .div-container-affiliate-forms {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
}

.div-container-create-account-description .div-container-affiliate-forms .logo-magafilio-img {
	width: 30%;
	margin-bottom: 30px;
}

.div-container-create-account-description .div-container-affiliate-forms .div-container-description-forms {
	width: 70%;
	margin-bottom: 20px;
}

.div-container-create-account-description .div-container-affiliate-forms .div-container-description-forms p.title-affiliate-forms {
	font-size: 35px;
	font-weight: 900;
	color: #FFFFFF !important;
	margin-bottom: 5px;
}

.div-container-create-account-description .div-container-affiliate-forms .div-container-description-forms p.title-affiliate-forms span {
	color: rgba(64, 218, 153, 1) !important;
}

.div-container-create-account-description .div-container-affiliate-forms .div-container-description-forms p.description-affiliate-forms {
	opacity: 0.75;
	font-size: 15px;
	font-weight: 400;
}

.div-container-button-back-to-login {
	margin-top: 30px;
}

.div-container-button-back-to-login .button-back-login-affiliate-forms {
	color: #40DA99 !important;
	text-decoration: none;
	font-size: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.div-container-button-back-to-login .icon-affiliate-forms {
	color: #40DA99 !important;
	margin-right: 8px;
}

.div-container-create-account-description .div-container-affiliate-forms .button-back-login-affiliate-forms {
	color: #40DA99 !important;
	text-decoration: none;
	font-size: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.div-container-create-account-description .div-container-affiliate-forms .icon-affiliate-forms {
	color: #40DA99 !important;
	margin-right: 8px;
}

.div-buttons-type-person {
	width: 60%;
	margin: auto;
}


.div-buttons-type-person .div-align-button {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 25px;
}

.div-buttons-type-person .div-align-button button {
	padding: 8px;
	font-weight: 400;
	font-size: 14px;
	line-height: 18px;
	margin-bottom: 10px;
}

.div-buttons-type-person .div-align-button button.true {
	background: #40DA99;
	box-shadow: inset 2px 2px 4px rgba(0, 0, 0, 0.25), inset -2px -2px 4px rgba(255, 255, 255, 0.25);
	border-radius: 11px;
	padding: 8px 10px;
	color: rgba(45, 47, 50, 1) !important;
	font-weight: 600;
	font-size: 14px;
	line-height: 18px;
}

.div-forms-page-groups {
	margin: 10px 0px 20px 0px;
}

.div-forms-page-groups p.title-groups {
	font-size: 20px;
	font-weight: 500;
	margin-bottom: 0px;
}

.div-forms-page-groups p.description-groups {
	font-size: 12px;
	margin-bottom: 0px;
	opacity: 0.7;
	font-weight: 300;
}

.div-politicy-platform {
	padding-bottom: 10px;
}

.div-politicy-platform p.paragrafo-politicy-platform {
	font-size: 10px;
	opacity: 0.6;
}

.div-politicy-platform a {
	color: #40DA99 !important;
}

.div-completed-registration  {
	display: flex;
	align-items: center;
	justify-content: center;
}

.div-completed-registration button.button-completed-registration {
	background: #40DA99;
	box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.5), -3px -3px 8px rgba(74, 74, 74, 0.5);
	border-radius: 23px;
	padding: 8px 20px;
	color: #2D2F32 !important;
	font-weight: 500;
	transition: background 0.6s;
}

.div-completed-registration button.button-completed-registration:disabled {
	opacity: 0.4;
	background: #40DA99;
	color: #2D2F32 !important;
	cursor: not-allowed;
}

.div-completed-registration button.button-completed-registration:hover {
	background: #FFFFFF;
}

.div-completed-registration button.button-back-registration {
	background: #2D2F32;
	box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.5), -3px -3px 8px rgba(74, 74, 74, 0.5);
	border-radius: 23px;
	padding: 8px 20px;
	color: #40DA99 !important;
	font-weight: 500;
	margin-right: 20px;
	transition: background 0.6s;
}

.div-completed-registration button.button-back-registration:hover {
	background: #FFFFFF;
	color: #2D2F32 !important;
}

/* Begin input */

.div-forms-create-affiliate .v-input__slot,
.div-forms-create-adveriser .v-input__slot,
.div-container-box-create-affiliate .v-input__slot,
.div-container-box-create-advertiser .v-input__slot
{
	margin: 0px;
}

.div-layout-container-page .v-text-field__slot {
	margin: 0px;
}

.div-layout-container-page .v-label.v-label--active.theme--light.primary--text {
	color: #40DA99 !important;
}

/* End input */

/* Begin google recaptcha */
.container-vue-recaptcha {
	margin-top: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
}

/*  */
/* Select Input */

.div-container-box-create-affiliate .v-input.v-text-field.v-select.v-select--chips.theme--light .v-input__slot {
	padding: 0px 15px;
}

.div-container-box-create-affiliate .v-input.v-text-field.v-select.v-select--chips.theme--light .v-input__control {
	margin-bottom: 8px;
}

.div-container-box-create-affiliate .v-input.v-text-field.v-select.v-select--chips.theme--light .v-select__selections .v-chip.v-chip--select-multi.theme--light {
	background: black;
	font-size: 8px;
}

.div-container-box-create-affiliate .v-select__selections {
	padding: 5px 10px;
}

/* End Select input */

/* Begin Froms advertiser */

.div-container-create-account .div-container-box-create-advertiser p.paragrafo-title-advertiser {
	font-size: 28px;
	font-weight: 700;
	margin-bottom: 0px;
	color: #FFFFFF !important;
}

.div-container-create-account .div-container-box-create-advertiser p.paragrafo-title-advertiser-cellphone {
	font-size: 1.5rem;
	font-weight: 700;
	margin-bottom: 8px;
	color: #FFFFFF !important;
}

.div-container-create-account .div-container-box-create-advertiser p.paragrafo-description-advertiser-cellphone {
	opacity: 0.7;
	font-size: 12px;
	margin-bottom: 0px;
}

.div-forms-create-advertiser {
	margin-top: 25px;
}

.div-forms-create-advertiser-button {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 15px;
}

.div-forms-create-advertiser-button button.button-registration-advertiser {
	background: #40DA99;
	box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.5), -3px -3px 8px rgba(74, 74, 74, 0.5);
	border-radius: 23px;
	padding: 8px 20px;
	color: #2D2F32 !important;
	font-weight: 500;
	transition: background 0.6s;
}

.div-forms-create-advertiser-button button.button-registration-advertiser:hover {
	background: #FFFFFF;
}

.div-forms-create-advertiser-button button.button-registration-advertiser:disabled {
	opacity: 0.4;
	background: #40DA99;
	color: #2D2F32 !important;
	cursor: not-allowed;
}

/*  End forms advertiser */

/* Begin dialog success */

.dialog-success-formulario {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.dialog-success-formulario p.welcome {
	font-weight: 900;
	font-size: 48px;
	line-height: 59px;
	text-align: center;
	color: #FFFFFF !important;
	margin-bottom: 15px;
}

.dialog-success-formulario p, .dialog-success-formulario strong {
	color: #FFFFFF !important;
}

.v-dialog.v-dialog--active .div-buttons-social-network {
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 15px 0px 25px 0px;
}

.v-dialog.v-dialog--active .div-buttons-social-network div.insta {
	background: radial-gradient(100% 990.15% at 0% 100%, #FDDA76 0%, #DD2A7B 51.04%, #8034B2 100%);
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
	border-radius: 40px;
	padding: 8px 20px;
}

.v-dialog.v-dialog--active .div-buttons-social-network div.insta a {
	text-decoration: none;
	font-size: 16px;
	font-weight: 900;
	margin-left: 8px;
	color: #FFFFFF !important;
	display: flex;
	align-items: center;
	justify-content: center;
}

.v-dialog.v-dialog--active .div-buttons-social-network div.insta img,
.v-dialog.v-dialog--active .div-buttons-social-network div.face img
{
	width: 25%;
}

.v-dialog.v-dialog--active .div-buttons-social-network div.face {
	background: radial-gradient(186% 604.16% at 18.43% 125.33%, #0065E0 0%, #11AEFF 100%);
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
	border-radius: 40px;
	padding: 8px 20px;
	margin-left: 15px;
}

.v-dialog.v-dialog--active .div-buttons-social-network div.face a {
	text-decoration: none;
	font-size: 16px;
	font-weight: 900;
	margin-left: 8px;
	color: #FFFFFF !important;
	display: flex;
	align-items: center;
	justify-content: center;
}

.v-dialog.v-dialog--active .div-buttons-social-network div.face a img,
.v-dialog.v-dialog--active .div-buttons-social-network div.insta a img
{
	margin-right: 8px;
}

.v-dialog.v-dialog--active .dialog-success-formulario .button-back-login-affiliate-forms {
	color: #40DA99 !important;
	text-decoration: none;
	font-size: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.v-dialog.v-dialog--active .dialog-success-formulario .icon-affiliate-forms {
	color: #40DA99 !important;
	margin-right: 8px;
}


/* .v-dialog.v-dialog--active  .div-ready-description-dialog-formulario {
	text-align: center;
	margin: 0px 0px 15px 0px;
}

.v-dialog.v-dialog--active .div-ready-description-dialog-formulario span  {
	opacity: 0.7;
} */

.button-dialog-status-success-formulario {
	background: #40DA99;
	box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.25), -3px -3px 8px rgba(74, 74, 74, 0.25);
	border-radius: 23px;
	padding: 4px 30px;
	color: #2D2F32 !important;
	font-weight: 600;
	transition: background 0.2s;
}

.button-dialog-status-success:hover {
	background: #FFF;
}

/* End dialog success */

/* Begin circular */

.div-forms-create-advertiser-button circle.v-progress-circular__overlay{
	color: #40DA99 !important;
}

.div-completed-registration circle.v-progress-circular__overlay{
	color: #40DA99 !important;
}

/* End circular */

@media(max-width: 960px) {
	.div-container-create-account {
		margin: auto;
	}
}

@media(max-width: 599px) {
	.div-container-create-account {
		margin: auto
	}
}

@media(max-width: 350px) {
	.div-container-create-account {
		padding-top: 40px;
		margin: auto;
	}
}

</style>
